import React, { SVGProps } from "react";

export default function SupDownArrowAlt(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10.5 12.8379L14.6158 7.89888L15.3841 8.53907L9.99995 15L4.61584 8.53907L5.38407 7.89888L9.49996 12.838V5H10.5V12.8379Z" fill="currentColor" />
    </svg>
  );
}
